import styled, { css } from '../../styled';
export const MenuTextContainer = styled.div `
  display: flex;
  align-items: center;

  ${({ isDivider }) => !isDivider &&
    css `
      padding: 0.06rem 0;
    `};
`;
export const MultiLineTextContainer = styled.div `
  display: flex;
  flex-direction: column;
  padding: 0.03125rem 0;

  * > span {
    display: block;
  }
`;
//# sourceMappingURL=TextContainer.js.map